import { create } from "zustand";
import type { ActionStatus } from "../lib/actionCenter";

// Persisted record of every action the BD has acted on — this doubles as the
// Notification History (Open items are everything NOT in here).
export interface ActionHistoryEntry {
  id: string;
  status: ActionStatus;
  at: number;
  title: string;
  kind: string;
}

const KEY = "cre-action-center-v1";

const load = (): Record<string, ActionHistoryEntry> => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const save = (data: Record<string, ActionHistoryEntry>) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // ignore quota / serialization errors
  }
};

interface ActionCenterState {
  history: Record<string, ActionHistoryEntry>;
  setStatus: (entry: ActionHistoryEntry) => void;
  reopen: (id: string) => void;
  clearHistory: () => void;
}

export const useActionCenterStore = create<ActionCenterState>((set, get) => ({
  history: load(),

  setStatus: (entry) => {
    const next = { ...get().history, [entry.id]: entry };
    save(next);
    set({ history: next });
  },

  reopen: (id) => {
    const next = { ...get().history };
    delete next[id];
    save(next);
    set({ history: next });
  },

  clearHistory: () => {
    save({});
    set({ history: {} });
  },
}));
